import bikeIcon from "@/assets/img/portal-home/Bike.svg";
import bonusAwansIcon from "@/assets/img/portal-home/Bonus_Avans.svg";
import bonusUhrdIcon from "@/assets/img/portal-home/Bonus_Uhrd.svg";
const bonusGoalsIcon = bonusUhrdIcon;
import busIcon from "@/assets/img/portal-home/Bus.svg";
import carIcon from "@/assets/img/portal-home/Car.svg";
import footerLogo from "@/assets/img/portal-home/BridgestoneFooter.png";
import giftBoxIcon from "@/assets/img/portal-home/gift-box.svg";
import bonusCampaignHeroImage from "@/assets/img/bonus/get-bonus-points.png";
import heroMainImage from "@/assets/img/portal-home/main.png";
import mediaExpertImage from "@/assets/img/portal-home/media-expert.png";
import promotion1Image from "@/assets/img/portal-home/dropped-image-1.png";
import promotion2Image from "@/assets/img/portal-home/dropped-image-2.png";
import promotion3Image from "@/assets/img/portal-home/dropped-image-3.png";
import promotion4Image from "@/assets/img/portal-home/dropped-image-4.png";
import promotion5Image from "@/assets/img/portal-home/dropped-image-5.png";
import promotion6Image from "@/assets/img/portal-home/dropped-image-6.png";
import promotion7Image from "@/assets/img/portal-home/dropped-image-7.png";
import promotionsIcon from "@/assets/img/portal-home/promotions.svg";
import rulesIcon from "@/assets/img/portal-home/Rules.svg";

export const portalHomeImages = {
  footerLogo,
  bonusCampaignHeroImage,
  heroMainImage,
  mediaExpertImage,
  promotions: [
    promotion1Image,
    promotion2Image,
    promotion3Image,
    promotion4Image,
    promotion5Image,
    promotion6Image,
    promotion7Image,
  ],
};

export const portalHomeIcons = {
  bonusAwans: bonusAwansIcon,
  bonusUhrd: bonusUhrdIcon,
  bonusGoals: bonusGoalsIcon,
  purchases: [carIcon, busIcon, bikeIcon],
  quickLinks: {
    knowledge: giftBoxIcon,
    promotions: promotionsIcon,
    rules: rulesIcon,
  },
};
